import styled from 'styled-components';

// Mesmo cabeçalho das outras telas do administrador: título h2, subtítulo
// strong e botões azuis à direita.
export const Container = styled.div`
  margin-top: 60px;

  strong {
    color: var(--text-primary);
    font-size: 14px;
  }
`;

export const CardeHeader = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;

  margin-bottom: 40px;
`;

export const CardButton = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
`;
